import type { Platform } from '@sparklayer-io/spark-dash-ui/types/platform';
import { t } from 'i18next';

export type Environment = 'live' | 'test';

// Kept out of `env-context` so a consumer can ask "is this Shopify?" without pulling in the
// provider, which reaches a themed primitive through its suspense fallback.

export function isShopify(platform?: Platform) {
  return platform === 'shopify' || platform === 'shopify_plus';
}

/** A platform with no aliases left: what {@link basePlatform} returns. */
export type BasePlatform = Exclude<Platform, 'shopify_plus'>;

/** Collapse platform aliases onto their base platform (e.g. `shopify_plus` -> `shopify`). */
export function basePlatform(platform?: Platform): BasePlatform | undefined {
  return platform === 'shopify_plus' ? 'shopify' : platform;
}

/** A platform's display name (e.g. `Shopify`), for strings that name the merchant's platform. */
export function platformLabel(platform?: Platform): string {
  return platform ? t(`labels:platforms.${platform}`) : '';
}

export function isLive(environment?: Environment) {
  return environment === 'live';
}

export function isTest(environment?: Environment) {
  return environment === 'test';
}
